export default __webpack_public_path__ + "static/media/gall_img.15f78da9.jpg";